import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import WveInputIntegerPair from 'SharedComponents/WveInputs/WveInputIntegerPair/WveInputIntegerPair';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';
import { updateDimensions, shouldChangeArtboard } from 'PreviewActions';
import {
  DIMENSIONS,
  DEVICE,
} from 'PreviewConstants/';
import {
  HEIGHT,
  WIDTH,
  UI,
} from 'SharedConstants/';

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 15px 0 0 10px;
`;

const InputIntegerPair = styled(WveInputIntegerPair)`
  display: inline-flex;
  margin-right: auto;
  width: 70%;
  align-items: center;
`;

class SizeSelector extends Component {
  handleChange = (event) => {
    const { updateDimensions } = this.props; // eslint-disable-line no-shadow
    const dimensions = {};
    if (event.target.dataset.id === '0') {
      dimensions.width = parseInt(event.target.value, 10);
    }
    if (event.target.dataset.id === '1') {
      dimensions.height = parseInt(event.target.value, 10);
    }
    updateDimensions(dimensions);
  };
  render() {
    const { size, deviceIsSelected } = this.props;
    const { handleChange } = this;
    return (<Row>
      <WveStyleElementLabel label="size" />
      <InputIntegerPair
        id="size"
        value={size}
        title={['w', 'h']}
        units={'px'}
        handleUpdate={handleChange}
        disabled={deviceIsSelected}
      />
    </Row>);
  }
}

SizeSelector.propTypes = {
  size: PropTypes.arrayOf(PropTypes.number),
  updateDimensions: PropTypes.func,
  deviceIsSelected: PropTypes.bool.isRequired,
};

SizeSelector.defaultProps = {
  size: [],
  updateDimensions: () => {},
};

const mapStateToProps = state => ({
  size: [state.getIn([UI, DIMENSIONS, WIDTH]), state.getIn([UI, DIMENSIONS, HEIGHT])],
  deviceIsSelected: state.getIn([UI, DEVICE]) !== null,
});

const mapDispatchToProps = dispatch => ({
  updateDimensions: dimensions =>
    dispatch(updateDimensions(dimensions)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SizeSelector);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/SizeSelector/SizeSelector.jsx